import React from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PostpaidBookingItinerarySearch from './search/PostpaidBookingItinerarySearch';
import PostpaidBookingItinerarySearchResults from './itineraries/PostpaidBookingItinerarySearchResults';
import PostpaidBookingSeatSelection from './seats/PostpaidBookingSeatSelection';
import PostpaidBookingSelectedSeats from './seats/PostpaidBookingSelectedSeats';
import SeatReleasePermissions from '../../modules/booking/seats/SeatReleasePermissions';
import { getItinerariesForPostpaidBooking } from '../../../actions';

const PostpaidBookingRoundTrip = ({
  dispatchGetItinerariesForPostpaidBooking,
}) => (
  <div>
    <PostpaidBookingItinerarySearch />
    <Row>
      <Col lg={6} md={12}>
        <PostpaidBookingItinerarySearchResults />
      </Col>
      <Col lg={4} md={6}>
        <PostpaidBookingSeatSelection />
      </Col>
      <Col lg={2} md={6}>
        <PostpaidBookingSelectedSeats />
        <SeatReleasePermissions
          formName="PostpaidBookingItinerarySearchForm"
          dispatchGetItineraries={dispatchGetItinerariesForPostpaidBooking}
        />
      </Col>
    </Row>
  </div>
);

PostpaidBookingRoundTrip.propTypes = {
  dispatchGetItinerariesForPostpaidBooking: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchGetItinerariesForPostpaidBooking: getItinerariesForPostpaidBooking,
};

export default connect(null, mapDispatchToProps)(PostpaidBookingRoundTrip);
